export default __webpack_public_path__ + "static/media/Arm-straps of Dark Malice.9645a49b.jpg";